import { ReactNode, useMemo } from 'react'
import { IExamResponse } from 'types/exam/types'
import { OrganOverlay, OrganToggleList } from './components'
import {
  getKnownOrganSegmentations,
  isApPaSubtype,
  isOrganSegmentationEnabled
} from './constants/organs'
import { useOrganSelection } from './context/OrganSelectionContext'

interface IOrganHighlights {
  overlay?: ReactNode
  sidePanel?: ReactNode
  bottomPanel?: ReactNode
}

/**
 * Overlay e controles dos órgãos para os modais do raio-X, ligados ao `OrganSelectionContext`.
 * Tudo `undefined` quando a feature está escondida (flag desligada ou exame fora de AP/PA).
 */
export const useOrganHighlights = (
  examData: IExamResponse
): IOrganHighlights => {
  const { selected, opacity, toggleOrgan, toggleAll, setOpacity } =
    useOrganSelection()

  const segmentations = useMemo(
    () => getKnownOrganSegmentations(examData.organ_segmentations),
    [examData.organ_segmentations]
  )

  if (!isOrganSegmentationEnabled() || !isApPaSubtype(examData.subtype)) {
    return {}
  }

  const renderControls = (layout: 'side' | 'bottom') => (
    <OrganToggleList
      layout={layout}
      segmentations={segmentations}
      selected={selected}
      opacity={opacity}
      onToggle={toggleOrgan}
      onToggleAll={() =>
        toggleAll(segmentations.map(item => item.segmentation_type))
      }
      onOpacityChange={setOpacity}
    />
  )

  return {
    overlay: (
      <OrganOverlay
        segmentations={segmentations}
        selected={selected}
        opacity={opacity}
      />
    ),
    sidePanel: renderControls('side'),
    bottomPanel: renderControls('bottom')
  }
}
